import { twMerge } from "tailwind-merge";
import usePresence from "hooks/usePresence";

export type PagePushProps = {
    visible: boolean;
    children: React.ReactNode;
    className?: string;
};

/**
 * Absolute-fill panel that slides in from the right (push) and out to the right (pop).
 * For in-panel navigation overlays (e.g. Mission create/view subpages).
 */
const PagePush: React.FC<PagePushProps> = ({ visible, children, className = "" }) => {
    const { mounted, state } = usePresence(visible);

    if (!mounted) return null;

    return (
        <div
            className={twMerge(
                "ios-page-push flex min-h-0 flex-col overflow-hidden rounded-r10 bg-black90",
                className
            )}
            data-state={state}
        >
            {children}
        </div>
    );
};

export default PagePush;
